import { ProcedureStepDefaultReviewerService as OvermapProcedureStepDefaultReviewerService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureStepDefaultReviewerService extends OvermapProcedureStepDefaultReviewerService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
